import styled from "styled-components";

const Button = styled.button`
  border: 1.5px solid limegreen;
  outline: none;
  padding: 0.5em 1em;
  background: black;
  color: limegreen;
  text-transform: capitalize;
  margin-right: 1em;
  font-size: 1em;
  cursor: pointer;
`;
export default Button;
